var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowUpIot(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 16,
    viewBox: "0 0 13 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.92132 1.09993L6.21421 0.392822L5.50711 1.09993L0.707107 5.89993L0 6.60704L1.41421 8.02125L2.12132 7.31414L5.21421 4.22125V8.20704V14.607V15.607H7.21421V14.607V8.20704V4.22125L10.3071 7.31414L11.0142 8.02125L12.4284 6.60704L11.7213 5.89993L6.92132 1.09993Z",
    fill: "#102A68"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowUpIot);
export default __webpack_public_path__ + "static/media/arrow_up_iot.4a56ede7935b7e2ce797efd74c059333.svg";
export { ForwardRef as ReactComponent };